export const getIsMobile = state =>
  state.browser.is.extraSmall || state.browser.is.small;

export const getWindowSize = state => state.browser.lessThan;
